export enum SupplierSortTypes {
  NAME = 'NAME',
  CATEGORY = 'CATEGORY',
  OPEN_AMOUNT = 'OPEN_AMOUNT',
  GENERATED_PROFIT = 'GENERATED_PROFIT',
  TOTAL_SPENT = 'TOTAL_SPENT',
  BTW_VAT = 'BTW_VAT',
}
